import { PureComponent } from 'react'

import { NamingProps } from '@/components/UberForm/Input/Naming/types'
import { splitProps } from '@/utils/collections'

import FormField, { FormlessFormField } from '../FormField'
import { NamingInput } from '../Input/Naming/NamingInput'
import { FormFieldProps } from '../types'

export default class NamingInputFormField extends PureComponent<
	Omit<NamingProps, 'onChange'> & FormFieldProps & { formless?: boolean }
> {
	render() {
		const fieldProps = { ...this.props }

		const inputProps = splitProps(fieldProps, [
			'node',
			'updateNaming',
			'className',
			'callNamingWorkingDataParams',
			'onFocusCustom',
			'onBlurCustom',
			'autoFocus',
			'readonlyContainer',
		])

		const FF = this.props.formless ? FormlessFormField : FormField

		return (
			<FF {...fieldProps}>
				<NamingInput {...inputProps} />
			</FF>
		)
	}
}
